/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { Badge, Box } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';

export default function ExhibitorStandBadge({
  session,
  ...rest
}: {
  session: string;
}) {
  return (
    <Box {...rest}>
      <Badge
        sx={{
          backgroundColor: 'brand.lightestBlue',
          ...colors[session],
        }}
      >
        {session}
      </Badge>
    </Box>
  );
}
const colors = {
  'Nov 6': { backgroundColor: '#e5740e', color: '#eff2f1' },
  'Nov 7': { backgroundColor: '#258e2a', color: '#eff2f1' },
  // // Nov 1 AM
  // '62ecd2fe123f1410cadbbba4': { backgroundColor: '#ffbd26', color: '#eff2f1' },
  // // Nov 1 PM
  // '62ecd313f394f910d1d6d29f': { backgroundColor: '#023d68', color: '#eff2f1' },
  // // Masterclass Oct 31
  // '62ecd092f28b1e10cc33eb56': { backgroundColor: '#a8b339', color: '#eff2f1' },
  // // Masterclass Nov 1
  // '62ecd0b262842e10d25d895f': { backgroundColor: '#e9971f', color: '#eff2f1' },
};
